import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoSpecialCharacter]'
})
export class NoSpecialCharacterDirective {
  @HostListener('keypress', ['$event']) onKeyDown(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Delete', 'Tab', ' '
    ];
    const isAllowedKey = allowedKeys.includes(event.key);
    const isAlphanumeric = /^[\w,.'#\/\\&:;-]+$/.test(event.key);

    if (!isAllowedKey && !isAlphanumeric) {
      event.preventDefault();
    }
  }
}
